import React from 'react';
import { motion } from 'framer-motion';
import { Clock, ShieldCheck, Lightbulb, Search, Sparkles, Infinity, HeartHandshake } from 'lucide-react';
const benefits = [{
  text: 'Encontrarás el patrón perfecto en minutos.',
  icon: Clock
}, {
  text: 'Te sentirás más segura siguiendo instrucciones claras.',
  icon: ShieldCheck
}, {
  text: 'Descubrirás nuevas ideas constantemente.',
  icon: Lightbulb
}, {
  text: 'Ahorrarás horas de búsqueda.',
  icon: Search
}, {
  text: 'Crearás piezas hermosas y profesionales.',
  icon: Sparkles
}, {
  text: 'Tendrás inspiración ilimitada.',
  icon: Infinity
}, {
  text: 'Podrás tejer para vos, regalar o vender.',
  icon: HeartHandshake
}];
export function Transformation() {
  return <section className="py-12 px-6 bg-white" data-id="element-215">
      <div className="max-w-4xl mx-auto" data-id="element-216">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-217">
          <h2 className="text-3xl md:text-4xl font-bold text-dark mb-4" data-id="element-218">
            CON ESTA BIBLIA...
          </h2>
          <div className="w-24 h-[1px] bg-gold mx-auto" data-id="element-219"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-220">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className={`flex items-start gap-4 p-6 rounded-2xl bg-cream/40 border border-cream hover:border-rose-light/50 transition-colors ${index === benefits.length - 1 ? 'md:col-span-2 md:max-w-md md:mx-auto' : ''}`} data-id="element-221">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-white shadow-sm flex items-center justify-center text-gold-dark" data-id="element-222">
                  <Icon className="w-6 h-6" strokeWidth={1.5} data-id="element-223" />
                </div>
                <p className="text-lg text-dark/80 font-medium pt-2 leading-snug" data-id="element-224">
                  {benefit.text}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}